import axios from 'axios';
import {API_URL} from 'configs'

export const LL_ACTIVITY_LOG_REQUEST = 'LL_ACTIVITY_LOG_REQUEST'
export const LL_ACTIVITY_LOG_SUCCESS = 'LL_ACTIVITY_LOG_SUCCESS'
export const LL_ACTIVITY_LOG_VALIDATION_ERROR = 'LL_ACTIVITY_LOG_VALIDATION_ERROR'
export const SHOW_SNACKBAR = 'SHOW_SNACKBAR';
export const HIDE_LL_ACTIVITY_LOG_FEILD_VALIDATION_ERROR = "HIDE_LL_ACTIVITY_LOG_FEILD_VALIDATION_ERROR"
export const REDIRECT_TO_LL_ACTIVITY_LOG_LIST = 'REDIRECT_TO_LL_ACTIVITY_LOG_LIST'
export const LL_ACTIVITY_LOG_GET_SUCCESS = 'LL_ACTIVITY_LOG_GET_SUCCESS'
export const ACTIVITIES_EXTRA_FIELDS_SUCCESS = "ACTIVITIES_EXTRA_FIELDS_SUCCESS"
export const LL_ACTIVITY_LOG_SERVER_SUCCESS = "LL_ACTIVITY_LOG_SERVER_SUCCESS"
export const LL_ACTIVITY_AGENT_REPORT_SERVER_SUCCESS = "LL_ACTIVITY_AGENT_REPORT_SERVER_SUCCESS"
export const LL_ACTIVITY_CLIENT_REPORT_SERVER_SUCCESS = "LL_ACTIVITY_CLIENT_REPORT_SERVER_SUCCESS"
const SHOW_LOADER = 'SHOW_LOADER';
const HIDE_LOADER = 'HIDE_LOADER';

const showCommonLoader = (label = '') => ({
  type: SHOW_LOADER,
  common_loder_label: label
})
const hideCommonLoader = () => ({
  type: HIDE_LOADER,
})

  const llactivityLogRequest = () => ({
    type: LL_ACTIVITY_LOG_REQUEST,
  })
  
  export const llactivityAgentReportServerListSuccess = () => ({
    type: LL_ACTIVITY_AGENT_REPORT_SERVER_SUCCESS,
  })

  export const llactivityClientReportServerListSuccess = () => ({
    type: LL_ACTIVITY_CLIENT_REPORT_SERVER_SUCCESS,
  })

  export const llactivityLogServerListSuccess = () => ({
    type: LL_ACTIVITY_LOG_SERVER_SUCCESS,
  })

  const llactivityLogListSuccess = llactivityLogList => ({
    type: LL_ACTIVITY_LOG_SUCCESS,
    llactivityLogList: llactivityLogList,
  }) 
      
  const llactivityLogFailure = notification => ({
      type: SHOW_SNACKBAR,
      snackbar_notification: notification,
      snackbar_notification_type: 'general_error'
  })
  const validationError = notification => ({
    type: LL_ACTIVITY_LOG_VALIDATION_ERROR,
    validation_error: notification,
  })
  const tokenError = notification => ({
    type: SHOW_SNACKBAR,
    snackbar_notification: notification,
    snackbar_notification_type: 'token_expire'
  })
  
  const llactivityLogAddUpadteSuccess = (message,action,dispatch) => {
    dispatch(llactivityLogSuccessNotification(message))
    dispatch(redirectToLLActivityLogList())
  }

  const getLLActivityLogSuccess = (response,action) => ({
    type: LL_ACTIVITY_LOG_GET_SUCCESS,
    record: response,
    actionType: action
  })

  const llactivityLogSuccessNotification = message => ({
    type: SHOW_SNACKBAR,
    snackbar_notification: message,
    snackbar_notification_type: 'success'
  })

  export const redirectToLLActivityLogList = () => ({
    type: REDIRECT_TO_LL_ACTIVITY_LOG_LIST,
  })

  export const hideLLActivityLogValidationError = (feild_key) => ({
    type: HIDE_LL_ACTIVITY_LOG_FEILD_VALIDATION_ERROR,
    feild_key: feild_key
  })
  
  export const addLLActivityLog = (data) => {
    var token  = localStorage.getItem("token")
    return dispatch => {
      dispatch(llactivityLogRequest())
      dispatch(showCommonLoader())
      return axios(API_URL+"lodgelink_activity_log/create", {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'Authorization':'Bearer '+token
        },
        data: data,
      })
      .then((response) => {
        llactivityLogAddUpadteSuccess('Activity Log Added Successfully','create',dispatch)
        dispatch(hideCommonLoader())
      }, (error) => {
        handleErrorResponse(error,dispatch)
        dispatch(hideCommonLoader())
      });
        
    }
  }

  export const addLLFollowupActivityLog = (data) => {
    var token  = localStorage.getItem("token")
    return dispatch => {
      dispatch(llactivityLogRequest())
      dispatch(showCommonLoader())
      return axios(API_URL+"lodgelink_activity_log/followup/"+data.id, {
        method: "POST",
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'Authorization':'Bearer '+token
        },
        data: data,
      })
      .then((response) => {
        llactivityLogAddUpadteSuccess('Activity Followup Added Successfully','followup',dispatch)
        dispatch(hideCommonLoader())
      }, (error) => {
        handleErrorResponse(error,dispatch)
        dispatch(hideCommonLoader())
      });
        
    }
  }

  export const updateLLActivityLog = (data) => {
    var token  = localStorage.getItem("token")
    return dispatch => {
      dispatch(llactivityLogRequest())
      dispatch(showCommonLoader())
      return axios(API_URL+"lodgelink_activity_log/update/"+data.id, {
        method: "PUT",
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'Authorization':'Bearer  '+token
        },
        data: data
      })
      .then((response) => {
        llactivityLogAddUpadteSuccess('Activity Log Updated Successfully','update',dispatch)
        dispatch(hideCommonLoader())
      }, (error) => {
        handleErrorResponse(error,dispatch)
        dispatch(hideCommonLoader())
      });
        
    }
  }  

  export const getLLActivityLogById = (id,action) => {
    var token  = localStorage.getItem("token")
    return dispatch => {
      dispatch(llactivityLogRequest())
      dispatch(showCommonLoader())
      return axios(API_URL+"lodgelink_activity_log/getById/"+id, {
        method: "GET",
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'Authorization':'Bearer  '+token
        },
      })
      .then((response) => {
        dispatch(getLLActivityLogSuccess(response.data,action))
        dispatch(hideCommonLoader())
      }, (error) => {
        handleErrorResponse(error,dispatch)
        dispatch(hideCommonLoader())
      });
        
    }
  } 

  export const deleteLLActivityLog = (llactivityLogId, object_viewed_id) => {
    var token  = localStorage.getItem("token")
    return dispatch => {
      dispatch(llactivityLogRequest())
      dispatch(showCommonLoader())
        return axios(API_URL+"lodgelink_activity_log/delete/"+llactivityLogId, {
          method: "DELETE",
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
            'Authorization':'Bearer '+token
          },
          data:{
            object_viewed_id
          }
        })
        .then((response) => {
          dispatch(llactivityLogSuccessNotification('Activity Log deleted successfully'))
          dispatch(hideCommonLoader())
        }, (error) => {
          handleErrorResponse(error,dispatch)
          dispatch(hideCommonLoader())
        });
      }  
        
  }
  

// handling error reponse   
const handleErrorResponse = (error,dispatch) => {
  try{
    if(error.response.status === 422 && error.response.data.error){
      dispatch(validationError(error.response.data.error))
    }
    else if(error.response.status === 401 && error.response.data.error){
      dispatch(tokenError(error.response.data.error.toString()))
    }
    else{
      let err = '';
      if(error.response.data.error){
        err = error.response.data.error.toString()
      }
      else{
        err = error.response.status+` `+error.response.statusText
      }
      dispatch(llactivityLogFailure(err))
    }
  }
  catch(e){
    dispatch(llactivityLogFailure('Unable to perform action.Something went wrong'))
  }  
}   